export default __webpack_public_path__ + "static/media/referAndEarn.296cf92b.png";